import { getShiftX } from './getShiftX';
import { updateIntegralXShift } from './internal/updateIntegralXShift';
import { updatePeaksXShift } from './internal/updatePeaksXShift';
import { updateRangesXShift } from './internal/updateRangesXShift';
export function updateXShift(datum) {
    const shiftX = getShiftX(datum);
    updatePeaksXShift(datum, shiftX);
    updateRangesXShift(datum, shiftX);
    updateIntegralXShift(datum, shiftX);
}
